function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { Component } from 'react';

/**
 * Drag n drop widget.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DnD = /*#__PURE__*/function (_Component) {
  function DnD(props) {
    var _this;
    _classCallCheck(this, DnD);
    _this = _callSuper(this, DnD, [props]);
    _this.state = {
      query: null
    };
    return _this;
  }
  _inherits(DnD, _Component);
  return _createClass(DnD, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var self = this;
      var FASTA_FORMAT = /^>/;
      $(document).ready(function () {
        var tgtMarker = $('.dnd-overlay');
        var dndError = function dndError(id) {
          $('.dnd-error').hide();
          $('#' + id + '-notification').show();
          tgtMarker.effect('fade', 2500);
        };
        $(document).on('dragenter', function (evt) {
          // Do not activate DnD if a modal is active.
          if ($.modalActive()) return;

          // Based on http://stackoverflow.com/a/8494918/1205465.
          // Contrary to what the above link says, the snippet below can't
          // distinguish directories from files. We handle that on drop.
          var dt = evt.originalEvent.dataTransfer;
          var isFile = dt.types && (dt.types.indexOf &&
          // Chrome and Safari
          dt.types.indexOf('Files') != -1 || dt.types.contains &&
          // Firefox
          dt.types.contains('application/x-moz-file'));
          if (!isFile) {
            return;
          }
          $('.dnd-error').hide();
          tgtMarker.stop(true, true);
          tgtMarker.show();
          dt.effectAllowed = 'copy';
          if (self.state.query.isEmpty()) {
            $('.dnd-overlay-overwrite').hide();
            $('.dnd-overlay-drop').show('drop', {
              direction: 'down'
            }, 'fast');
          } else {
            $('.dnd-overlay-drop').hide();
            $('.dnd-overlay-overwrite').show('drop', {
              direction: 'down'
            }, 'fast');
          }
        }).on('dragleave', '.dnd-overlay', function (evt) {
          tgtMarker.hide();
          $('.dnd-overlay-drop').hide();
          $('.dnd-overlay-overwrite').hide();
        }).on('dragover', '.dnd-overlay', function (evt) {
          evt.originalEvent.dataTransfer.dropEffect = 'copy';
          evt.preventDefault();
        }).on('drop', '.dnd-overlay', function (evt) {
          evt.preventDefault();
          evt.stopPropagation();
          var indicator = $('#sequence-file');
          self.state.query.focus();
          var files = evt.originalEvent.dataTransfer.files;
          if (files.length > 1) {
            dndError('dnd-multi');
            return;
          }
          var file = files[0];
          if (file.size > 250 * 1048576) {
            dndError('dnd-large-file');
            return;
          }
          var reader = new FileReader();
          reader.onload = function (e) {
            var content = e.target.result;
            if (FASTA_FORMAT.test(content)) {
              indicator.text(file.name + ' ');
              self.state.query.value(content);
              tgtMarker.hide();
            } else {
              // apparently not FASTA
              dndError('dnd-format');
            }
          };
          reader.onerror = function (e) {
            // Couldn't read. Means dropped stuff wasn't FASTA file.
            dndError('dnd-format');
          };
          reader.readAsText(file);
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx("div", {
        className: "dnd-overlay absolute left-0 top-0 w-full h-full bg-gray-200 bg-opacity-75 z-40",
        style: {
          display: 'none'
        },
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col space-y-4 h-full items-center justify-center dnd-overlay-container text-2xl",
          children: [/*#__PURE__*/_jsxs("p", {
            className: "dnd-overlay-drop flex items-center space-x-4",
            style: {
              display: 'none'
            },
            children: [/*#__PURE__*/_jsx("i", {
              className: "fa fa-2x fa-file"
            }), "Drop query sequence file here"]
          }), /*#__PURE__*/_jsxs("p", {
            className: "dnd-overlay-overwrite flex items-center space-x-4",
            style: {
              display: 'none'
            },
            children: [/*#__PURE__*/_jsx("i", {
              className: "fa fa-2x fa-file"
            }), /*#__PURE__*/_jsx("span", {
              className: "text-red-800",
              children: "Overwrite"
            }), "&nbps;query sequence file"]
          }), /*#__PURE__*/_jsxs("div", {
            className: "dnd-errors text-red-800",
            children: [/*#__PURE__*/_jsx("div", {
              className: "dnd-error row",
              id: "dnd-multi-notification",
              style: {
                display: 'none'
              },
              children: "One file at a time please."
            }), /*#__PURE__*/_jsx("div", {
              className: "dnd-error row",
              id: "dnd-large-file-notification",
              style: {
                display: 'none'
              },
              children: "Too big a file. Can only do less than 250 MB. >_<"
            }), /*#__PURE__*/_jsx("div", {
              className: "dnd-error row",
              id: "dnd-format-notification",
              style: {
                display: 'none'
              },
              children: "Only FASTA files please."
            })]
          })]
        })
      });
    }
  }]);
}(Component);